import type { Middleware } from '@reduxjs/toolkit';
import { isRejectedWithValue } from '@reduxjs/toolkit';
import { createError } from '@/helpers/api';

interface RejectedPayload {
  data?: unknown;
  status?: number | string;
}

interface RejectedMeta {
  baseQueryMeta?: {
    request?: { url?: string };
    response?: { headers?: Headers };
  };
}

export const rtkQueryErrorLogger: Middleware = (_api) => {
  return (next) => {
    return (action) => {
      if (isRejectedWithValue(action)) {
        const payload = action.payload as RejectedPayload;
        if (payload && (payload.data || payload.status)) {
          const meta = action.meta as RejectedMeta;
          createError({
            status: payload.status,
            response: payload.data,
            url: meta.baseQueryMeta?.request?.url,
            requestId:
              meta.baseQueryMeta?.response?.headers?.get('X-Request-Id'),
          });
        }
      }
      return next(action);
    };
  };
};
